import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { setTrim } from '../../../../lib/common';
import EditTabTabMainModal from '../../../../views/tag/common/modal/EditTagTabMainModal';
import withModal from '../../../../lib/hoc/withModal';
import { tagActions } from '../../../../store/modules/tag';

class EditTagTabMainModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  태그 트렌드 키워드 리스트 메모
       */
      memo: null,
    };
  }

  /**
   *  태그 탭 메인 편집하기
   */
  onSubmit = () => {
    const { form, data, editTagTabMain } = this.props;
    const { memo } = this.state;
    const { tagTrendKeywordIdList, tagFollowSelectedList } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      editTagTabMain({
        tagTrendKeywordIdList,
        tagTrendKeywordMemo: setTrim(memo),
        tagFollowSelectedList,
      });

      /**
       *  모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'editTabMainModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <EditTabTabMainModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.tag.editTabMainModal.isOpen,
    data: state.tag.editTabMainModal.data,
  };
};

const mapDispatchToProps = {
  editTagTabMain: tagActions.editTagTabMain,
  toggleModal: tagActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(EditTagTabMainModalContainer)));
